export default "/images/mail_chimp.png?8e50552df16c4c472e0e21efcbbc949b";